import NtxTable from '@components/DataTable/NtxTable';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Quick = ({ Persons, onIdsChange }) => {
  const { t, i18n } = useTranslation();
  const [selectedId, setSelectedId] = useState(null); // تخزين المعرف المحدد

  useEffect(() => {
    if (selectedId !== null && onIdsChange) {
      onIdsChange([selectedId]); // تمرير ID كمصفوفة
    }
  }, [selectedId, onIdsChange]);

  const columns = [
    {
      title: <></>,
      key: 'radioButton',
      sortable: false
    },
    { title: t('EmployeeName'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'num' },
    { title: t('Payroll'), key: 'Payroll' },
    { title: t('Status'), key: 'hasRun' }
  ];

  const tableData = Persons?.map(item => {
    let rowClass = selectedId === item.assignmentId ? 'table-active ' : ''; // إضافة صف مميز للمعرف المحدد
    return {
      radioButton: (
        <Form.Check
          type='radio'
          name='employeeRadio'
          id={`radio-${item.assignmentId}`}
          checked={selectedId === item.assignmentId}
          onChange={() => setSelectedId(item.assignmentId)}
          className='custom-radio-btn '
          disabled={item.hasRun}
        />
      ),
      Name: i18n.language === 'ar' ? item.personName2 : item.personName,
      num: item.employeeNumber,
      Payroll: i18n.language === 'ar' ? item.payrollName2 : item.payrollName,
      hasRun: (
        <div className='d-flex align-items-center'>
          <span className={`badge ${item.hasRun ? 'bg-success' : 'bg-danger'} me-2`}>
            {item.hasRun ? t('Paid') : t('Unpaid')}
          </span>
        </div>
      ),

      assignmentId: item.assignmentId,
      isRun: item.hasRun,

      rowClass // استخدم rowClass هنا
    };
  });

  // دالة renderRow مخصصة لجعل الصف كامل قابل للنقر
  const renderRow = (row, rowIndex) => {
    return (
      <tr
        key={rowIndex}
        className={row.rowClass}
        onClick={() => {
          if (!row.isRun) {
            setSelectedId(row.assignmentId);
          }

          // setSelectedId(row.assignmentId);
        }}
        style={{ cursor: row.isRun ? 'not-allowed' : 'pointer' }}
      >
        {columns.map(column => (
          <td key={column.key} className={'align-middle ' + (column.className || '')}>
            {row[column.key]}
          </td>
        ))}
      </tr>
    );
  };

  return (
    <>
      <NtxTable
        data={tableData || []}
        columns={columns}
        dataPerPage={10}
        theadClass=''
        tableClass='table text-nowrap table-hover '
        enableSearch
        showRecordsSelector
        renderRow={renderRow}
      />

      <style>
        {`
       

          .custom-radio-btn .form-check-input {
  width: 1.8em;
  height: 1.8em;
  // border-radius: 0.25em; /* زوايا مربعة */
  border: 2px solid rgba(173, 181, 189, 0.42); /* لون الحدود */
  cursor: pointer;
}

.custom-radio-btn .form-check-input:checked {
  background-color:rgba(var(--bs-theme-rgb), 1 ); /* لون الخلفية عند التحديد */
  border-color:rgba(var(--bs-theme-rgb), 1 );
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 24 24'%3e%3cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3e%3c/svg%3e");

    // background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23fff'%3e%3cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3e%3c/svg%3e");
 
 }
 
        `}
      </style>
    </>
  );
};

export default Quick;
